import { Box, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { Globe } from 'lucide-react';

import { SUPPORTED_LANGUAGES, useLanguage } from './LanguageContext';

function LanguageSwitcher({ size = 'small', sx }) {
  const { lang, setLang } = useLanguage();

  return (
    <FormControl size={size} sx={{ minWidth: 160, ...sx }}>
      <InputLabel id="lang-switcher-label">Language</InputLabel>
      <Select
        labelId="lang-switcher-label"
        label="Language"
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        startAdornment={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              pl: 1,
              pr: 0.5,
              color: 'var(--text-secondary)',
            }}
          >
            <Globe size={16} />
          </Box>
        }
      >
        {SUPPORTED_LANGUAGES.map((l) => (
          <MenuItem key={l.code} value={l.code}>
            {l.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default LanguageSwitcher;
